import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as productActions from '../store/actions/product.actions';

@Injectable()
export class ProductOverviewResolver {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve() {
    this.store.dispatch(productActions.loadData());
    return of(true);
  }
}
